var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"nav",attrs:{"id":"page"}},[(_vm.$store.state.user.showLoginPane)?_c('el-scrollbar',{staticStyle:{"overflow-x":"hidden !important"}},[_c('router-view')],1):_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }